import { render, staticRenderFns } from "./CostInOne.vue?vue&type=template&id=a9b84738&scoped=true&"
import script from "./CostInOne.vue?vue&type=script&lang=js&"
export * from "./CostInOne.vue?vue&type=script&lang=js&"
import style0 from "./CostInOne.vue?vue&type=style&index=0&id=a9b84738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b84738",
  null
  
)

export default component.exports